import {classes} from './AsideLoader.st.css';
import React from 'react';

export const AsideLoader = () => {
  return <div key={'aside-third'} className={classes.root}></div>;
};
